import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { RenewalChip } from "@/components/Primitives";

function daysUntil(iso) {
  if (!iso) return 0;
  const d = new Date(iso);
  return Math.round((d - new Date()) / (1000 * 60 * 60 * 24));
}

export default function Contracts() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/contracts").then(r => setItems(r.data)); }, []);
  const sorted = [...items].sort((a,b) => daysUntil(a.expires_at) - daysUntil(b.expires_at));
  return (
    <div className="space-y-4">
      <div>
        <div className="text-[10px] uppercase tracking-[0.18em] text-zinc-500 font-mono">Contract Governance</div>
        <h1 className="font-display text-3xl font-semibold tracking-tight mt-1">Contracts ({items.length})</h1>
      </div>
      <div className="bg-zinc-950 border border-zinc-900 rounded-md overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-zinc-900/50 text-[10px] uppercase tracking-widest text-zinc-500 font-mono"><tr><th className="text-left px-4 py-3">Title</th><th className="text-left px-4 py-3">Client</th><th className="text-left px-4 py-3">Term</th><th className="text-left px-4 py-3">Value</th><th className="text-left px-4 py-3">Expires</th><th className="text-left px-4 py-3">Auto-renew</th></tr></thead>
          <tbody>
            {sorted.map(c => (
              <tr key={c.id} className="border-b border-zinc-900 hover:bg-zinc-900/40">
                <td className="px-4 py-2">{c.title}</td>
                <td className="px-4 py-2 font-mono text-xs text-zinc-500">{c.client_id}</td>
                <td className="px-4 py-2 font-mono text-xs">{c.term_months}mo</td>
                <td className="px-4 py-2 font-mono text-emerald-400">₱{c.value_php?.toLocaleString()}</td>
                <td className="px-4 py-2"><RenewalChip daysLeft={daysUntil(c.expires_at)} /></td>
                <td className="px-4 py-2 font-mono text-xs">{c.auto_renew?"yes":"no"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
